export function getCharacters() {
    const searchKey = 'characters'
    const apiKey = '$2a$10$wYb8od3G.RfSJLB6Kb1wp.VYI6Xk4Nkc6xra3ungw4B2cr4.1P8RK'
    return (dispatch, getState) => {
        fetch(`https://www.potterapi.com/v1/${searchKey}/?key=${apiKey}`)
            .then(res => res.json())
            .then(data => {
                dispatch({
                    type: "ADD_HARRYPOTTER_CHARACTERS",
                    harryPottersCharacters: data
                });
            })
            .catch(err => {
                console.log(err)
            })
    };
}

export function getCharacter(id) {
    const searchKey = 'characters'
    const apiKey = '$2a$10$wYb8od3G.RfSJLB6Kb1wp.VYI6Xk4Nkc6xra3ungw4B2cr4.1P8RK'
    return (dispatch, getState) => {
        fetch(`https://www.potterapi.com/v1/${searchKey}/${id}/?key=${apiKey}`)
            .then(res => res.json())
            .then(data => {
                dispatch({
                    type: "ADD_CHARACTER",
                    character: data
                });
            })
            .catch(err => {
                console.log(err)
            })
    };
}